// extracted by mini-css-extract-plugin
export default {"item":"constructor-item_item__Oy8Zo"};